import React from 'react';


const Blogs = () => {
    return (
        <div>
  


        
 blog  
        </div>
    );
};

export default Blogs;